import { render } from "./loginSidebar.vue?vue&type=template&id=5ebb9776"
import script from "./loginSidebar.vue?vue&type=script&lang=js"
export * from "./loginSidebar.vue?vue&type=script&lang=js"

import "./loginSidebar.vue?vue&type=style&index=0&id=5ebb9776&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__